import React from "react";
import { Container } from "react-bootstrap";

const Contact = () => {
  return (
    <div id="contact" className="py-5 mt-5">
      <Container>
        <h5 className="py-5">
          If you have any question or If you want to work together <br /> feel
          free to contact me
        </h5>
        <button className="common-btn mb-5">
          <a href="https://form.jotform.com/213324262517449">Contact-Me</a>
        </button>
      </Container>
    </div>
  );
};

export default Contact;
